// 资源地址默认加上 https://resources.laihua.com
export function handleAssetsUrl(url) {
	if (!url) return '';
  if (url.indexOf('http') === 0) {
    return url;
  }
  let reg = /^\//;
  let qiniuAssetsUrl = 'https://resources.laihua.com';

  let reg2 = new RegExp(qiniuAssetsUrl + '/', 'g');
  url = url.replace(reg2, '');
  if (!reg.test(url)) {
    return qiniuAssetsUrl + '/' + url;
  } else {
    return qiniuAssetsUrl + url;
  }
}

// 字体加载
const font_list = [];

export async function loadFont(ffu = '') {
  if(font_list.indexOf(ffu) > -1 || ffu.split('/').length < 2) return;
  let bitterFontFace = new FontFace(
    ffu.split('/').pop(),
    `url(${handleAssetsUrl(ffu)})`
  );
  document.fonts.add(bitterFontFace);
  let loadPro = new Promise(resolve => {
    bitterFontFace.load().then(() => {
      resolve(true);
    }).catch(() => {
      resolve(false);
    });
  });
  let ok = await loadPro;
  font_list.push(ffu);
  if(!ok) {
    console.error(`${ffu}字体加载失败`);
  }
}


// WEBPACK FOOTER //
// ./src/components/draftPreview/comFunc.js